import React from 'react';
import { Box, Typography } from '@mui/material';

interface Parameter { type: string; name: string; dataType: string; required?: boolean; description?: string; }
interface ApiParametersTableProps { parameters: Parameter[]; title?: string; }

const ApiParametersTable: React.FC<ApiParametersTableProps> = ({ parameters, title = "Parameters" }) => {
  return (
    <Box sx={{ marginBottom: 2 }}>
      <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>{title}</Typography>
      <Box sx={{
        border: '1px solid #e1e5e9',
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>

        <Box sx={{
          display: 'flex',
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid #e1e5e9',
          minHeight: 48,
          alignItems: 'center'
        }}>
          <Box sx={{
            flex: 1,
            padding: 2,
            borderRight: '1px solid #e1e5e9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Typography variant='body2' fontSize={11} fontWeight={700} sx={{ color: '#374151' }}>Type</Typography>
          </Box>
          <Box sx={{
            flex: 1,
            padding: 2,
            borderRight: '1px solid #e1e5e9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Typography variant='body2' fontSize={11} fontWeight={700} sx={{ color: '#374151', textAlign: 'center', width: '100%' }}>Parameter Name</Typography>
          </Box>
          <Box sx={{
            flex: 1,
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Typography variant='body2' fontSize={11} fontWeight={700} sx={{ color: '#374151', textAlign: 'center', width: '100%' }}>Data Type</Typography>
          </Box>
        </Box>

        {parameters.map((param, index) => (
          <Box key={index} sx={{
            display: 'flex',
            borderBottom: index < parameters.length - 1 ? '1px solid #e1e5e9' : 'none',
            minHeight: 40,
            alignItems: 'center',
            '&:hover': { backgroundColor: '#f1f3f4' },
            transition: 'background-color 0.2s ease'
          }}>
            <Box sx={{
              flex: 1,
              padding: 2,
              borderRight: '1px solid #e1e5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Typography
                variant='body2'
                fontSize={10}
                fontWeight={600}
                sx={{
                  backgroundColor: param.type === 'HEAD' ? '#b893f8ff' : param.type === 'POST' ? '#edbb66ff' : '#60efc0ff',
                  color: 'white',
                  padding: '4px 6px',
                  borderRadius: '4px',
                  textAlign: 'center',
                  minWidth: '55px',
                  fontSize: '10px',
                  fontWeight: 700
                }}
              >
                {param.type}
              </Typography>
            </Box>
            <Box sx={{
              flex: 1,
              padding: 2,
              borderRight: '1px solid #e1e5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Typography variant='body2' fontSize={11} sx={{ color: '#374151', fontWeight: 500, textAlign: 'center', width: '100%' }}>
                {param.name}
                {param.required &&
                  <Typography component="span" sx={{ color: '#ef4444', fontSize: 11, marginLeft: 0.5, fontWeight: 600 }}>*</Typography>
                }
              </Typography>
            </Box>
            <Box sx={{
              flex: 1,
              padding: 2,
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <Typography
                variant='body2'
                fontSize={11}
                sx={{
                  color: '#7c3aed',
                  fontFamily: 'Monaco, Consolas, "Courier New", monospace',
                  fontWeight: 600,
                  backgroundColor: '#f3f4f6',
                  padding: '4px 8px',
                  borderRadius: '4px'
                }}
              >
                {param.dataType}
              </Typography>
              {param.description &&
                <Typography variant='body2' fontSize={10} sx={{ color: '#6b7280', marginTop: 0.5, lineHeight: 1.4 }}>
                  {param.description}
                </Typography>
              }
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ApiParametersTable;
